module.exports = __webpack_public_path__ + "img/level-medium.a485e2dc.png";